// Theme.js
const theme = {
  buttons: {
    primary: {
      backgroundColor: "transparent",

      color: "black",
      // 기타 버튼 스타일 속성들...
    },
  },
};

export default theme;
